import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useFormik } from "formik"
import * as Yup from "yup"

// components
import { CButton, CImage } from '@coreui/react-pro'
import Select from 'react-select';
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'
import useToastMessage from 'src/helpers/toast-message'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnGameVoucherList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import { singleGamesOptionsSelect, singleIsUsedOptionSelect, singleIsExpiredOptionSelect } from '../../helpers/format-options'

const GameVoucherList = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })
  const [showModalInputFile, setShowModalInputFile] = useState({ show: false })

  const [gameActiveOptions, setGameActiveOpstions] = useState([])
  const [gameOptions, setGamesOptions] = useState([])
  const [gameVoucherList, setGameVoucherList] = useState([]);
  const [gameVoucherListCount, setGameVoucherListCount] = useState(0);
  const [gameVoucherListPerPage, setGameVoucherListPerPage] = useState(10);
  const [activeGameVoucherListPage, setActiveGameVoucherListPage] = useState(1);
  const [searchGameVoucherListFilter, setSearchGameVoucherListFilter] = useState("");
  const [columnGameVoucherListSorter, setColumnGameVoucherListSorter] = useState({ column: "createdAt", state: "desc" });
  const [columnFilter, setColumnFilter] = useState({})

  const [updateColumnList, setUpdateColumnList] = useState(columnGameVoucherList)

  const formik = useFormik({
    initialValues: {
      gamevoucher_game_value: null,
      files: [],
    },
    validationSchema: Yup.object().shape({
      gamevoucher_game_value: Yup.object().shape({
        label: Yup.string().required('Please select game name.')
      }).required('Please select game name.'),
      files: Yup.array()
      .min(1, 'At least one file is required')
      .required('File are required'),
    }),
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  useEffect(() => {
    let queries = {
      search: searchGameVoucherListFilter,
      limit: gameVoucherListPerPage,
      offset: gameVoucherListPerPage * activeGameVoucherListPage - gameVoucherListPerPage,
      sort:
        (columnGameVoucherListSorter &&
          `${columnGameVoucherListSorter.column}-${columnGameVoucherListSorter.state}`) ||
        "",
    };
    if (columnFilter) {
      Object.keys(columnFilter).forEach((key) => {
        if (columnFilter[key]) {
          queries[key] = columnFilter[key].value
        } else {
          queries[key] = ''
        }
      })
    }
    queries = formUrlQuery(queries);
    fetchAllGameVouchers(queries);
  }, [
    searchGameVoucherListFilter,
    gameVoucherListPerPage,
    activeGameVoucherListPage,
    columnGameVoucherListSorter,
    columnFilter
  ]);

  const handleSearchItems = (search) => {
    setActiveGameVoucherListPage(1)
    setSearchGameVoucherListFilter(search);
  }

  useEffect(() => {
    fetchAllGames()
  }, [])

  useEffect(() => {
    let columnList = updateColumnList?.map((list) => {
      let data = list

      if (data.key == 'is_used') {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={singleIsUsedOptionSelect()}
              value={columnFilter.is_used}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue); // Ini yang penting! Meneruskan nilai ke SmartTable
                setColumnFilter((prevState) => ({
                  ...prevState,
                  is_used: selectedValue
                }));
              }}
              isClearable
            />
          )
        }
      }

      if (data.key == 'expired_date') {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={singleIsExpiredOptionSelect()}
              value={columnFilter.is_expired}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue); // Ini yang penting! Meneruskan nilai ke SmartTable
                setColumnFilter((prevState) => ({
                  ...prevState,
                  is_expired: selectedValue
                }));
              }}
              isClearable
            />
          )
        }
      }

      if (data.key == 'game_name' && gameActiveOptions?.length > 0) {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={gameActiveOptions}
              value={columnFilter.game_id}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue); // Ini yang penting! Meneruskan nilai ke SmartTable
                setColumnFilter((prevState) => ({
                  ...prevState,
                  game_id: selectedValue
                }));
              }}
              isClearable
            />
          )
        }
      }

      return data
    })

    setUpdateColumnList(columnList)
  }, [columnFilter, gameActiveOptions])

  const fetchAllGames = () => {
    Axios({
      method: "get",
      url: "/api/gamepass/v1/game/list",
    })
      .then(({ data }) => {
        if (data?.success) {
          let gameList = data.value
          let options = singleGamesOptionsSelect(gameList)
          setGamesOptions(options)

          let filterGameActiveOptions = []
          if (gameList?.length > 0) {
            filterGameActiveOptions = gameList?.filter((game) => game.is_active == true)
          }

          if (filterGameActiveOptions?.length > 0) {
            filterGameActiveOptions = filterGameActiveOptions.map((element) => {
              return {
                label: element?.game_name,
                value: element?.id,
              }
            })
          }

          setGameActiveOpstions(filterGameActiveOptions)

          let columnList = updateColumnList?.map((list) => {
            let data = list

            if (data.key == 'game_name') {
              data.filter = (_, onChange) => {
                return (
                  <Select
                    options={filterGameActiveOptions}
                    value={columnFilter.game_id}
                    onChange={(e) => {
                      const selectedValue = e;
                      onChange(selectedValue); // Ini yang penting! Meneruskan nilai ke SmartTable
                      setColumnFilter((prevState) => ({
                        ...prevState,
                        game_id: selectedValue
                      }));
                    }}
                    isClearable
                  />
                )
              }
            }

            return data
          })

          setUpdateColumnList(columnList)
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const fetchAllGameVouchers = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/gamepass/v1/voucher/game/list?${queries}`
    })
      .then(({ data }) => {
        const tempGameVoucherList = data?.value?.map((d) => ({
          ...d,
          is_used: d.is_used ? "Yes" : "No",
          game_name: d?.game?.game_name
        }));

        setGameVoucherList(tempGameVoucherList);
        if (activeGameVoucherListPage === 1) {
          setGameVoucherListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  };

  const handleInputValue = (values) => {
    let formData = new FormData()
    formData.append('game_id', values.gamevoucher_game_value.value)
    if (values.files?.length > 0) {
      formData.append('file', values.files[0])
    }

    return formData
  }

  const handlePost = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: `/api/gamepass/v1/voucher/game/import`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowModalInputFile({ show: false })
          fetchAllGameVouchers()
          formik.resetForm()
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        let errMsg = err.response.data.message
        if (errMsg) {
          showError(errMsg)
        }
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  const handleDeleteConfirmation = (index = 0, name) => {
    let prevValue = formik.values[name]

    let isDeleted = true
    let url = `/api/gamepass/v1/voucher/game/delete/${showConfirmDelete?.item?.id}`

    if (prevValue && prevValue[index] instanceof File) {
      isDeleted = false
    }

    if (isDeleted) {
      dispatch({
        type: 'SET_IS_LOADING',
        isLoading: true
      })
      Axios({
        method: "delete",
        url,
      })
        .then(({ data }) => {
          if (data?.success) {
            fetchAllGameVouchers()
            window.location.reload()
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          dispatch({
            type: 'SET_IS_LOADING',
            isLoading: false
          })
        })
    } else {
      formik.setValues((values) => ({
        ...values,
        [name]: values[name]?.filter((_, i) => i !== index)
      }), false)
    }

    setShowConfirmDelete({ show: false, item: {} })
  }

  const handleSelectGame = (data) => {    
    if (data) {
      formik.setValues((prevValues) => ({
       ...prevValues,
       gamevoucher_game_value: data
     }), false)
    }
  }

  const handleFileInput = (file) => {
    if (file) {
      formik.setValues((prevValues) => ({
        ...prevValues,
        files: file
      }))
    }
  }

  const handleShowModalInputFile = () => {
    setShowModalInputFile({ show: !showModalInputFile.show })

    if (!showModalInputFile.show) {
      formik.resetForm()
    }
  }

  return (
    <>
      {
        showModalInputFile?.show && (
          <AppModalConfirmation 
            confirmationType='gamevoucher-bulk-import'
            showModal={showModalInputFile}
            setShowModal={setShowModalInputFile}
            values={formik.values}
            errors={formik.errors}
            handleConfirmation={() => formik.handleSubmit()}
            headerTitle={"Please input file import"}
            handleFileInput={handleFileInput}
            handleSelectInput={handleSelectGame}
            gameOptions={gameOptions}
            handleConfirmDelete={setShowConfirmDelete}
          />
        )
      }
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={showConfirmDelete?.item?.name  ? showConfirmDelete?.item?.name : showConfirmDelete?.item?.voucher_code}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={handleShowModalInputFile}>
          Import
        </CButton>
        <CButton style={styleButtonVars2} onClick={() => navigate('/game-voucher/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Game Voucher
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Game Voucher List</h4>}
        bodyContent={
          <AppTable
            gameVoucherListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={updateColumnList}
            tableContent={gameVoucherList}
            contentPerPage={gameVoucherListPerPage}
            activeContentPage={activeGameVoucherListPage}
            contentCount={gameVoucherListCount}
            searchContentFilter={searchGameVoucherListFilter}
            setActiveContentPage={setActiveGameVoucherListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setGameVoucherListPerPage}
            setColumnContentSorter={setColumnGameVoucherListSorter}
            isShowColumnFilter={true}
          />
        }
      />
    </>
  )
}

export default GameVoucherList